export const initialDataDebug = {
  email: 'teste@teste.com',
  name: 'Teste',
  phone: '1234567890',
  card_number: '42424242424242',
  card_expiration: '12/35',
  card_cvv: '123',
  card_name: 'Teste',
  identificationType: 'RUC',
  identificationNumber: '33547090000194',
  billingAddress: {
    city: 'São Paulo',
    neighborhood: 'Jardim Paulista',
    number: '123',
    postcode: '01414000',
    region: 'LIM',
    street: 'Avenida Paulista'
  }
}
